import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { GlobalLoading } from "@/components/GlobalLoading";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import ResultsMaster from "@/pages/ResultsMaster";
import ActionRecommendations from "@/pages/ActionRecommendationsMasterAI";
import Paywall from "@/pages/Paywall";
import SalesEngine from "@/pages/SalesEngine";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SalesAuditWizardMasterWrapper from "@/pages/SalesAuditWizardMasterWrapper";
import SalesAuditWizardMaster from "@/pages/SalesAuditWizardMaster";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";

const queryClient = new QueryClient();

/**
 * Stripe-Redirect-Handling passiert jetzt DIREKT in index.html
 * als synchrones inline-Script — das ist die einzig zuverlässige Methode.
 *
 * Dieser App.tsx Code ist nur noch das reine Routing.
 */
function ScrollToTop(): null {
  const { pathname } = useLocation();
  
  // Scroll to top on every route change
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  
  return null;
}

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
      <Toaster />
      <Sonner />
      <GlobalLoading />
      <MotionConfig reducedMotion="user">
        <HashRouter>
            <ScrollToTop />
            <Routes>
              <Route path={ROUTE_PATHS.HOME} element={<Home />} />
              <Route path={ROUTE_PATHS.SALES_ENGINE} element={<SalesEngine />} />
              <Route path={ROUTE_PATHS.AUDIT} element={<SalesAuditWizardMasterWrapper />} />
              {/* SalesAuditWizardMaster is used inside Wrapper */}
              <Route path={ROUTE_PATHS.RESULTS_MASTER} element={<ResultsMaster />} />
              <Route path={ROUTE_PATHS.PAYWALL} element={<Paywall />} />
              <Route path={ROUTE_PATHS.ACTION_RECOMMENDATIONS} element={<ActionRecommendations />} />
              <Route path={ROUTE_PATHS.UEBER_UNS} element={<About />} />
              <Route path={ROUTE_PATHS.KONTAKT} element={<Contact />} />
              <Route path={ROUTE_PATHS.ADMIN_LOGIN} element={<AdminLogin />} />
              <Route path={ROUTE_PATHS.ADMIN} element={<AdminDashboard />} />
              <Route path={ROUTE_PATHS.IMPRESSUM} element={<Impressum />} />
              <Route path={ROUTE_PATHS.DATENSCHUTZ} element={<Datenschutz />} />
              <Route path={ROUTE_PATHS.AGB} element={<AGB />} />
              <Route path="/audit-direct" element={<SalesAuditWizardMaster />} />
            </Routes>
        </HashRouter>
      </MotionConfig>
      </TooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
